import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config.js";

export default {
  props: {
    items: {
      type: [Array, Object],
      default: () => [],
    },
  },

  data() {
    return {
      company: this.$store.state.company,
      filesToReplace: [],
      foldersToReplace: [],
      folder: null,
      selected: null,
      folders: [],
    };
  },
  created() {
    this.setVariables();
  },
  methods: {
    setVariables() {
      let folder = null;

      if (Array.isArray(this.items)) {
        //is multiple items
        const newFilesToReplace = [];
        const newFoldersToReplace = [];

        this.items.forEach((item, index) => {
          if (index === 0) {
            //set folder id
            folder = item.parent_id
              ? item.parent_id
              : item.folder_id
              ? item.folder_id
              : item.id;
            this.mySpace = item.myspace;
          }

          if (item.extension) {
            newFilesToReplace.push(item.id);
          } else {
            newFoldersToReplace.push(item.id);
          }
        });

        this.filesToReplace = newFilesToReplace;
        this.foldersToReplace = newFoldersToReplace;
      } else {
        //set folder id
        folder = this.items.parent_id
          ? this.items.parent_id
          : this.items.folder_id
          ? this.items.folder_id
          : this.items.id;
        this.mySpace = this.items.myspace;

        //is one item
        if (this.items.extension) {
          this.filesToReplace = [this.items.id];
        } else {
          this.foldersToReplace = [this.items.id];
        }
      }

      this.$axios
        .get(`${baseUrl}/folder?folder=${folder}&myspace${this.mySpace}`, {
          responseType: "json",
        })
        .then((response) => {
          this.folders = response.data;
        });

      this.$axios
        .get(
          baseUrl +
            "/folderdetail?folder=" +
            folder +
            "&myspace" +
            this.mySpace,
          {
            responseType: "json",
          }
        )
        .then((r) => {
          this.folder = r.data;
        });
    },
    back() {
      if (this.folder == null) {
        this.openFolder(null, 1, null);
      } else {
        this.openFolder(this.folder.parent_id, 1, null);
      }
    },
    openFolder(id, count, folder) {
      if (id == null) {
        this.$axios
          .get(baseUrl + "/roots?myspace=" + this.mySpace, {
            responseType: "json",
          })
          .then((response) => {
            this.folders = response.data;
            if (this.mySpace != "1") {
              this.folders.shift();
            }
          });
        this.folder = null;
      } else {
        if (count > 0) {
          this.$axios
            .get(baseUrl + "/folder?folder=" + id + "&myspace" + this.mySpace, {
              responseType: "json",
            })
            .then((response) => {
              this.folders = response.data;
            });
          this.$axios
            .get(
              baseUrl +
                "/folderdetail?folder=" +
                id +
                "&myspace" +
                this.mySpace,
              {
                responseType: "json",
              }
            )
            .then((response) => {
              this.folder = response.data;
            });
        } else {
          this.folder = folder;
        }
      }
    },
    move() {
      let formData = new FormData();
      formData.append("myspace", this.mySpace);
      formData.append("parent", this.folder.id);
      formData.append("folders", this.foldersToReplace);
      formData.append("files", this.filesToReplace);

      if (this.folder.id == "myspace") {
        formData.set("parent", null);
      }

      this.$axios
        .post(baseUrl + "/changeparentmultiple", formData)
        .then((r) => {
          //close all windows
          EventBus.$emit(`closeallactions`);
          EventBus.$emit(`tree-overview-reset`);

          if (
            this.mySpace == "1" &&
            this.folder.id == "null" &&
            this.foldersToReplace
          ) {
            this.$router.push(
              "/" +
                this.$store.state.company +
                "/myspace/expanded/" +
                this.folder.id
            );
          } else if (this.mySpace == "1") {
            this.$router.push(
              "/" +
                this.$store.state.company +
                "/myspace/expanded/" +
                this.foldersToReplace[0]
            );
          } else {
            this.$router.push(
              "/" +
                this.$store.state.company +
                "/home/expanded/" +
                this.folder.id
            );
          }
        });
    },
    inSelected: function (currentFolder) {
      let length = this.foldersToReplace.length;
      for (let i = 0; i < length; i++) {
        if (this.foldersToReplace[i] === currentFolder) {
          return true;
        }
      }
      return false;
    },
  },
};
